// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { getType } from 'typesafe-actions';

import { SupportStateType } from '../../types/Model';
import { RootAction, actionCreatorsList } from '../rootActionCreator';

export interface updateSupportStatusPageState {
  supportStatus: SupportStateType;
  isLoading: boolean;
  isListFetching: boolean;
  error?: Error;
}

const {
  updateSupportStatusActions,
} = actionCreatorsList;

export const initialState: updateSupportStatusPageState = {
  supportStatus: SupportStateType.Closed,
  isLoading: true,
  isListFetching: true,
};

const supportStatusReducer = (state = initialState, action: RootAction): updateSupportStatusPageState => {
  switch (action.type) {
    case getType(updateSupportStatusActions.request): {
      return {
        ...state,
        isLoading: true,
        error: undefined
      };
    }
    case getType(updateSupportStatusActions.success): {
      const { supportStatus } = action.payload
      return {
        ...state,
        isLoading: false,
        supportStatus
      };
    }
    case getType(updateSupportStatusActions.failure): {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    }
    default: {
      return state;
    }
  }
}

export { supportStatusReducer as default };
